import React, { useEffect, useState } from "react";
import {
  deleteAppProducts,
  getAppProducts,
} from "../../../apis/AppProductsApi";
import { Button, Table } from "antd";
import { Link } from "react-router-dom";
import useTableDragScroll from "../../../hooks/useTableDragScroll";

const AppProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductsList();
    setLoading(false);
  }, []);

  useTableDragScroll([loading, products]);

  const fetchProductsList = async () => {
    try {
      const res = await getAppProducts();
      console.log(res);
      setProducts(res?.result || []);
      setLoading(false);
    } catch (e) {
      console.log(e, "error");
    }
  };
  const deleteRecord = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Product?",
    );
    if (isConfirmed) {
      // console.log(id, "iddddddd");
      const deleteRes = await deleteAppProducts(id);
      console.log(deleteRes, "ttttttt");
      setLoading(true);
      fetchProductsList();
    }
  };
  const lang = [
    {
      id: "en",
      name: "English",
    },
    {
      id: "de",
      name: "German",
    },
    {
      id: "pl",
      name: "Polish",
    },
  ];
  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "10%",
    },
    {
      title: "Product Name",
      //   render: (text, record) => <img src={record.image} />,
      dataIndex: "name",
      width: "30%",
    },
    {
      title: "Description",
      dataIndex: "description",
      width: "30%",
    },
    {
      title: "Minimum Amount",
      dataIndex: "minAmount",
      width: "30%",
    },
    {
      title: "Language",
      dataIndex: "language",
      width: "30%",
      render: (value) => {
        const language = lang.find((item) => item.id === value);
        return language ? language.name : "-";
      },
    },
    // {
    //   title: "Zoneee",
    //   dataIndex: "zone",
    //   width: "30%",
    // },
    // {
    //   title: "CreatedAt",
    //   dataIndex: "createdAt",
    //   width: "20%",
    //   //   render: (text) => text.split("T")[0],
    // },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to={`/AddProd_list/${record.id}`}
              // onClick={() => getAppProducts(record.id)}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => deleteRecord(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
      width: "20%",
    },
  ];
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Link to="/AddProd_list" className="btn btn-primary mb-3">
              Add Products
            </Link>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    Array.isArray(products) && products.length > 0
                      ? products
                      : []
                  }
                  rowKey="id"
                  //   loading={loading}
                  //   pagination={{ pageSize: 10 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default AppProducts;
